import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import loadable from '@loadable/component';
import Cookies from 'universal-cookie';
import { showOverlay } from '../../client/redux/overlays/actions';
import { OverlayId } from '../../client/components/Overlays/types';
import StateInterface from '../../client/redux/types';
import useConfig from '../../client/hooks/useConfig';
import useGa from '../../client/hooks/useGa';
import { categoryActions } from '../../client/redux/category/actions';
import useFetchingAction from '../../client/hooks/useFetchingAction/useFetchingAction';
import { VictorQaClasses } from '../../common/qaIds';
import { TrackHeaderActions } from '../../client/ga/types';
import EventListener, { createHeaderEvents } from '../../common/events';
import { getHeaderBarBannerActionsIfNeeded } from '../../client/redux/headerBarBanner/actions';
import { useOverlayStateChecker } from '../../client/components/Overlays/useOverlayStateChecker';
import { combineThunks } from '../../client/redux/utils';
import useClubTabProps from './useClubTabProps';
import OneHeader from './OneHeader';
import OneHeaderContainer from './OneHeaderContainer';

const BurgerFlyout = loadable(() => import('./Overlays/BurgerFlyout/index'));
const DetachableNavBar = loadable(() => import('./NavigationBar/DetachableNavBar'));
const DetachableBannerBar = loadable(() => import('./BarBanner/DetachableBarBanner'));

const ConnectedOneHeader: React.FC<{ detachedHeaderMode: boolean }> = ({ detachedHeaderMode }) => {
    const minOrderValue = useSelector<StateInterface, number | null>(
        state => state.configurations.shipping.minOrderValue
    );
    const wishListCount = useSelector<StateInterface, number>(state => state.wishlist.count);
    const overlayStateChecker = useOverlayStateChecker();
    const BurgerMenuOverlay = overlayStateChecker(OverlayId.BURGER_MENU);
    const isBurgerMenuActive = BurgerMenuOverlay && BurgerMenuOverlay.isActive;

    const dispatch = useDispatch();
    const ga = useGa();
    const config = useConfig();

    const {
        links: { clubBaseUrl },
    } = config;
    useEffect(() => {
        dispatch(getHeaderBarBannerActionsIfNeeded());
    }, [dispatch]);

    const thunks = [categoryActions.thunk()];
    useFetchingAction(combineThunks(...thunks));

    const iconsCountProps = { minOrderValue, wishListCount };

    const openBurgerMenu = () => {
        dispatch(showOverlay(OverlayId.BURGER_MENU));

        ga.oneHeader.trackBurgerMenuIconClick();
    };

    const handleLogoClick = () => {
        ga.oneHeader.trackHeaderAction('logoclick', TrackHeaderActions.HeaderLogoClick);
    };

    const { clubText, clubUrl, isClubTabHighlighted } = useClubTabProps();

    useEffect(() => {
        const events = createHeaderEvents(dispatch, config, new Cookies());
        const eventsHandler = EventListener(events);
        return () => eventsHandler.dispose();
    }, [dispatch, config]);

    return (
        <>
            <DetachableBannerBar detachedHeaderMode={detachedHeaderMode} />
            <OneHeaderContainer className={VictorQaClasses.oneHeader} detachedHeaderMode={detachedHeaderMode}>
                {isBurgerMenuActive && <BurgerFlyout />}
                <OneHeader
                    isClubTabHighlighted={isClubTabHighlighted}
                    handleBurgerMenuIconClick={openBurgerMenu}
                    handleLogoClick={handleLogoClick}
                    clubText={clubText}
                    clubUrl={clubUrl}
                    clubBaseUrl={clubBaseUrl}
                    {...iconsCountProps}
                />
            </OneHeaderContainer>
            <div className="wwOneHeader__Shadow--inner" />
            <DetachableNavBar detachedHeaderMode={detachedHeaderMode} burgerMenuHandler={openBurgerMenu} />
        </>
    );
};

export default ConnectedOneHeader;
